<template>
  <div>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="openDiag" v-if="!isShowOnly && baseInfo">关联子班</el-button>
      <el-button size="medium" @click="openDiagResult" v-if="isEditClass || isShowOnly">分班结果</el-button>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormDataInit"
      :isShowOnly="isShowOnly"
      :tableConfig="tableConfigInit"
      :paginConfig="paginConfigInit"
      ref="lyTable"
    >
      <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
      <template v-slot:classroom="row">{{ row.classroom | arrFilter }}</template>
      <template v-slot:action="row">
        <el-button @click="openDiagDiy(row)" type="primary" v-if="isEditClass" size="mini">人工分班</el-button>
        <el-button @click="delRelation(row)" type="danger" size="mini">删除关联</el-button>
      </template>
    </ly-table>

    <el-dialog title="关联子班" :visible.sync="dialogVisible" width="1260px" class="child-class-dg">
      <div class="hd">
        <div class="fl">
          <el-input placeholder="班级名称" v-model="searchFormData.query"></el-input>
          <remote-search
            :options="teacher_id"
            ref="teach"
            @input="value => change(value, 'teacher_id')"
            :isCache="true"
          />
        </div>
        <el-button @click="searchAll">查 询</el-button>
        <div class="fr" v-if="!isShowOnly">
          <el-button type="primary" @click="bindClass" :loading="loading" :disabled="!selectionAll.length">确定关联</el-button>
        </div>
      </div>
      <ly-table
        :getTableData="getTableDataAll"
        :tableHeader="tableHeaderAll"
        :searchFormData="searchFormData"
        :isShowOnly="isShowOnly"
        :tableConfig="tableConfigAll"
        ref="lyTableAll"
      >
        <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
        <template v-slot:classroom="row">{{ row.classroom | arrFilter }}</template>
      </ly-table>
    </el-dialog>
    <el-dialog
      :title="isConfim ? '分班结果（已确认）' : '分班结果'"
      append-to-body
      :visible.sync="dialogVisibleResult"
      width="1260px"
      class="child-class-dg"
    >
      <div class="hd">
        <div class="fl">
          <el-select v-model="searchFormDataResult.class_id" placeholder="全部班级" clearable>
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-input placeholder="学员姓名/身份证号" v-model="searchFormDataResult.query"></el-input>
        </div>
        <el-button type="primary" @click="searchReslut">查 询</el-button>
      </div>
      <ly-table
        :getTableData="getTableDataResult"
        :tableHeader="tableHeaderResult"
        :searchFormData="searchFormDataResult"
        :isShowOnly="isShowOnly"
        :tableConfig="tableConfigResult"
        ref="lyTableResult"
      >
        <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
        <template v-slot:classroom="row">{{ row.classroom | arrFilter }}</template>
        <template v-slot:action="row">
          <el-button type="primary" @click="resetSplit([row.id])" size="mini">重置分班</el-button>
        </template>
      </ly-table>
      <div class="result-b" v-if="!isShowOnly">
        <el-button @click="resetSplit(selectionResult.map(item => item.id))">批量重置分班结果</el-button>
        <el-button type="danger" @click="resetSplitAll()">重置所有分班结果</el-button>
        <el-button type="primary" @click="confimSplitAll()">确认所有分班结果</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`人工分班（${choose.name}）`"
      :visible.sync="dialogVisibleDiy"
      width="1260px"
      class="child-class-dg"
    >
      <div class="hd">
        <div class="fl">
          <el-input
            placeholder="学员姓名/身份证号"
            v-model="searchFormDataDiy.query"
            @keydown.enter.native="searchDiy"
          ></el-input>
        </div>
        <el-button @click="searchDiy">查 询</el-button>
        <div class="fr" v-if="!isShowOnly">
          <el-button type="primary" :loading="loadingDiy" @click="createSignUpRelation">确 认</el-button>
        </div>
      </div>
      <ly-table
        :getTableData="getTableDataDiy"
        :tableHeader="tableHeaderDiy"
        :isShowOnly="isShowOnly"
        :searchFormData="searchFormDataDiy"
        :tableConfig="tableConfigDiy"
        ref="lyTableDiy"
      >
        <template v-slot:teacher="row">{{ row.teacher | teacherFilter }}</template>
        <template v-slot:classroom="row">{{ row.classroom | arrFilter }}</template>
      </ly-table>
    </el-dialog>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :action="false" :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Select, Option, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import { classApi } from '@/api';
import { childClassTable, childClassDiyTable, childClassSplitResultTable } from '@/utils/tableHeaderClass';
import { teacher_ids } from '@/utils/formConfigCommon';
import RemoteSearch from '@/components/common/RemoteSearch';

export default {
  name: 'ChildClass',
  components: {
    LyTable,
    ElDialog: Dialog,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    RemoteSearch
  },
  props: {
    onlyShow: {
      type: Boolean,
      default: () => false
    },
    classId: {
      type: Number
    },
    baseInfo: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      dialogVisibleSc: false,
      scTime: {}, // 课程表信息
      dialogVisibleResult: false,
      loading: false,
      years: [],
      terms: [],
      dialogVisible: false,
      tableConfigInit: {},
      paginConfigInit: {
        isHide: parseInt(this.$route.params.id, 10) < 0
      },
      searchFormDataInit: {},
      tableHeader: [
        ...childClassTable,
        {
          value: 'action',
          name: '操作',
          option: {
            width: '200px'
          }
        }
      ],
      getTableData: classApi.childClassList,
      // 关联弹窗列表
      selectionAll: [],
      tableConfigAll: {
        action: {
          'selection-change': selection => {
            this.selectionAll = selection;
          }
        }
      },
      searchFormData: {
        query: '',
        teacher_id: ''
      },
      tableHeaderAll: childClassTable,
      getTableDataAll: classApi.allClassSelect,
      teacher_id: {
        ...teacher_ids.options,
        multiple: false,
        key: 'teacher_id',
        clearable: true,
        placeholder: '教师关键字检索'
      },
      // 分班结果弹窗
      getTableDataResult: classApi.splitClassSignUpList,
      searchFormDataResult: {
        class_id: '',
        query: ''
      },
      tableHeaderResult: childClassSplitResultTable,
      options: [],
      tableConfigResult: {
        action: {
          'selection-change': selection => {
            this.selectionResult = selection;
          }
        }
      },
      selectionResult: [],
      // 人工分班弹窗
      loadingDiy: false,
      selectionDiy: [],
      dialogVisibleDiy: false,
      searchFormDataDiy: {
        query: ''
      },
      tableConfigDiy: {
        action: {
          'selection-change': selection => {
            this.selectionDiy = selection;
          }
        }
      },
      getTableDataDiy: classApi.singUpList,
      tableHeaderDiy: childClassDiyTable,
      choose: {}
    };
  },
  filters: {
    arrFilter(value) {
      return Array.from(new Set(value || [])).join(',');
    },
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    }
  },
  computed: {
    // 是否编辑班级
    isEditClass() {
      return this.origin_class_id > 0;
    },
    isConfim() {
      return this.$route.query.is_confirm_split_class === 'true';
    },
    isShowOnly() {
      // 仅作展示，不可进行任意操作 || 已经确认分班
      return this.onlyShow || this.isConfim;
    },
    origin_class_id() {
      if (this.isCopy) {
        return -1;
      }
      return parseInt(this.$route.params.id, 10) || this.classId;
    },
    isCopy() {
      return this.$route.query.isCopy === 'true';
    }
  },
  watch: {
    origin_class_id() {
      this.search();
    }
  },
  mounted() {
    this.search();
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
      }
    });
  },
  methods: {
    getClassIds() {
      const { data } = this.tableConfigInit;
      if (!this.isEditClass && data) return data.map(item => item.id);
      return false;
    },
    openDiag() {
      this.dialogVisible = true;
      setTimeout(() => this.searchAll(), 0);
    },
    setSearch(key) {
      if (this.origin_class_id > 0) {
        this[key].origin_class_id = this.origin_class_id;
      } else {
        delete this[key].origin_class_id;
      }
    },
    search() {
      this.setSearch('searchFormDataInit');
      if (this.isEditClass || this.isShowOnly) this.$refs.lyTable.setData();
      else {
        this.tableConfigInit = {
          data: this.tableConfigInit.data || []
        };
      }
    },
    searchAll() {
      this.setSearch('searchFormData');
      this.searchFormData.spec_id = this.baseInfo.specialized_subject_id;
      this.searchFormData.term = this.baseInfo.term;
      this.searchFormData.year = this.baseInfo.year;
      this.$refs.lyTableAll.setData();
    },
    searchDiy() {
      this.setSearch('searchFormDataDiy');
      this.$refs.lyTableDiy.setData();
    },
    searchReslut() {
      this.searchFormDataResult.origin_class_id = this.origin_class_id;
      this.$refs.lyTableResult.setData();
    },
    change(value, key) {
      if (key === 'org_id' && this.searchFormData[key] !== value) {
        this.$refs.spec.clear();
      }
      this.searchFormData[key] = value;
    },
    async bindClass() {
      if (this.isEditClass) {
        this.loading = true;
        this.tableConfigInit = {};
        const res = await classApi.createRelation({
          params: {
            origin_class_id: this.origin_class_id,
            child_class_ids: this.selectionAll.map(item => item.id)
          }
        });
        if (res) {
          this.$message.success(res.msg || '关联成功！');
          this.search();
        }
      } else {
        let data = this.selectionAll || [];
        if (this.tableConfigInit.data) {
          const ids = this.selectionAll.map(item => item.id);
          const temp = this.tableConfigInit.data.filter(item => {
            if (ids.includes(item.id)) return false;
            return true;
          });
          data = [...data, ...temp];
        }
        this.tableConfigInit = {
          data
        };
      }
      this.dialogVisible = false;
      this.loading = false;
    },
    delRelation({ id }) {
      if (this.isEditClass) {
        classApi
          .relationUnbind({
            params: {
              child_class_ids: [id],
              origin_class_id: this.origin_class_id
            }
          })
          .then(res => {
            if (res) {
              this.$message.success(res.msg || '删除成功！');
              this.search();
            }
          });
      } else {
        this.tableConfigInit = {
          data: this.tableConfigInit.data.filter(item => item.id !== id)
        };
      }
    },
    openDiagResult() {
      this.dialogVisibleResult = true;
      setTimeout(() => this.searchReslut(), 0);
      classApi
        .splitClassList({
          origin_class_id: this.origin_class_id
        })
        .then(res => {
          if (res && res.data && res.data.list) {
            this.options = res.data.list;
          }
        });
    },
    openDiagDiy(row) {
      this.choose = { ...row };
      this.dialogVisibleDiy = true;
      setTimeout(() => this.searchDiy(), 0);
    },
    async createSignUpRelation() {
      if (this.selectionDiy.length === 0) {
        this.$message.warning('请勾选分配到该班级学员！');
        return;
      }
      this.loadingDiy = true;
      const res = await classApi.createSignUpRelation({
        origin_class_id: this.origin_class_id,
        split_class_id: this.choose.id,
        params: {
          origin_sign_up_ids: this.selectionDiy.map(item => item.id)
        }
      });
      if (res) {
        this.$message.success(res.msg || '分班成功！');
        this.searchDiy();
      }
      this.loadingDiy = false;
    },
    resetSplit(result_ids) {
      if (!Array.isArray(result_ids) || result_ids.length === 0) {
        this.$message.warning('请勾选需要重置的学员！');
        return;
      }
      classApi
        .splitClassRest({
          origin_class_id: this.origin_class_id,
          params: {
            result_ids
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '重置分班成功');
            this.searchReslut();
          }
        });
    },
    resetSplitAll() {
      classApi
        .splitClassRestAll({
          origin_class_id: this.origin_class_id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '重置成功！');
          }
        });
    },
    confimSplitAll() {
      classApi
        .splitClassRestConfirm({
          origin_class_id: this.origin_class_id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '确认成功！');
          }
        });
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    }
  }
};
</script>
<style lang="less">
.child-class-dg {
  .hd {
    overflow: hidden;
    margin-bottom: 10px;
    .fl {
      display: flex;
      > * {
        margin-right: 10px;
        flex: 1;
        width: 181px;
      }
      .ly-search-comp .el-input {
        width: auto;
      }
    }
  }
  .result-b {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
</style>
